import { FC } from 'react'
import { Typography } from "@mui/material"
import { formatNumber } from '../../../common/FormatNumber'

interface ViewCounterProps {
    count?: number
}

export const ViewCounter: FC<ViewCounterProps> = ({ count = 0 }) => {
    return (
        <Typography variant="black-14-medium">Просмотров: {formatNumber(count)}</Typography>
    )
}
